import React from 'react';
import AdminSubscriptionRow from './adminSubscriptionRow';

const AdminSubscriptionsTable = ({ subscriptions, setSortMethod = () => {} }) => {
  return (
    <table className="table table-striped admin__table admin__table">
      <thead>
        <tr>
          <th onClick={() => setSortMethod('id')} className="sortable" scope="col">
            ID
          </th>
          <th scope="col">User</th>
          <th scope="col">Status</th>
          <th scope="col">Delivery</th>
          <th scope="col">Content</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        {subscriptions?.map((subscription, index) => (
          <AdminSubscriptionRow subscription={subscription} key={index} />
        ))}
      </tbody>
    </table>
  );
};

export default AdminSubscriptionsTable;
